export default class ProductService {
  constructor($http) {
    this.$http = $http;
  }

  get_categories() {
    return this.$http.get('/admin/marketplace/products/get_categories');
  }

  get_groups(category_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/get_groups_by_category',
      params: {category_id: category_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_products(group_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/get_products_by_group',
      params: {group_id: group_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_products_for_price_groups(group_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/get_products_by_group_for_price_groups',
      params: {group_id: group_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_product_properties_by_category(category_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/get_product_properties_by_category',
      params: {category_id: category_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_product_properties_by_group(group_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/get_product_properties_by_group',
      params: {group_id: group_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_product_end_uses(product_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/get_product_end_uses',
      params: {product_id: product_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_group_data(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/products/get_group_data',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_brand_data(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/products/get_brand_data',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  search_product_groups_by_title(title) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/search_product_groups_by_title',
      params: {title: title}
    }).then(function(response) {
      return response.data;
    });
  }

  search_products_by_title(title) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/products/search_products_by_title',
      params: {title: title}
    }).then(function(response) {
      return response.data;
    });
  }

  search_products_by_filter(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/products/search_products_by_filter',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_price_groups(filter) {
    return this.$http.post(
      '/admin/marketplace/products/get_price_groups',
      {filter: filter, authenticity_token: window.token}
    );
  }

  create_price_group(product_group_id, title) {
    return this.$http.post(
      '/admin/marketplace/products/create_price_group',
      {product_group_id: product_group_id, title: title, authenticity_token: window.token}
    );
  }

  get_price_group_members(group_id) {
    return this.$http.get('/admin/marketplace/products/get_price_group_members/' + group_id);
  }

  get_all_products() {
    return this.$http.get('/admin/marketplace/products/get_all_products');
  }

  add_price_group_member(group_id, product_id) {
    return this.$http.post(
      '/admin/marketplace/products/add_price_group_member',
      {group_id: group_id, product_id: product_id, authenticity_token: window.token}
    );
  }

  remove_price_group_member(group_id, product_id) {
    return this.$http.post(
      '/admin/marketplace/products/remove_price_group_member',
      {group_id: group_id, product_id: product_id, authenticity_token: window.token}
    );
  }

  update_price_group_title(group_id, title) {
    return this.$http.post(
      '/admin/marketplace/products/update_price_group_title',
      {group_id: group_id, title: title, authenticity_token: window.token}
    );
  }

  get_all_groups() {
    return this.$http.get('/admin/marketplace/products/get_all_groups');
  }

  get_groups_with_ranges() {
    return this.$http.get('/admin/marketplace/products/get_groups_with_ranges');
  }

  get_groups_with_specs() {
    return this.$http.get('/admin/marketplace/products/get_groups_with_specs');
  }

  update_group_ranges(group) {
    return this.$http.post(
      '/admin/marketplace/products/update_group_ranges',
      {group: group, authenticity_token: window.token}
    );
  }

  update_range_supplier_pricings(group_id) {
    return this.$http.post(
      '/admin/marketplace/products/update_range_supplier_pricings',
      {group_id: group_id, authenticity_token: window.token}
    );
  }

  update_range_buyer_pricings(group_id) {
    return this.$http.post(
      '/admin/marketplace/products/update_range_buyer_pricings',
      {group_id: group_id, authenticity_token: window.token}
    );
  }

  update_price_group_supplier_pricings(price_group_id) {
    return this.$http.post(
      '/admin/marketplace/products/update_price_group_supplier_pricings',
      {price_group_id: price_group_id, authenticity_token: window.token}
    );
  }

  update_price_group_buyer_pricings(price_group_id) {
    return this.$http.post(
      '/admin/marketplace/products/update_price_group_buyer_pricings',
      {price_group_id: price_group_id, authenticity_token: window.token}
    );
  }

  get_product_group_ranges(product_group_id, is_reels) {
    return this.$http.post(
      '/admin/marketplace/products/get_product_group_ranges',
      {product_group_id: product_group_id, is_reels: is_reels, authenticity_token: window.token}
    );
  }

  get_product_group_specs(product_group_ids, filter) {
    return this.$http.post(
      '/admin/marketplace/products/get_product_group_specs',
      {product_group_ids: product_group_ids, filter: filter, authenticity_token: window.token}
    );
  }

  update_product_group_specs(product_group_id, specs) {
    return this.$http.post(
      '/admin/marketplace/products/update_product_group_specs',
      {product_group_id: product_group_id, specs: specs, authenticity_token: window.token}
    );
  }

  delete_price_group(price_group_id) {
    return this.$http.post(
      '/admin/marketplace/products/delete_price_group',
      {price_group_id: price_group_id, authenticity_token: window.token}
    );
  }

  add_end_uses_to_products(products, end_uses) {
    return this.$http.post(
      '/admin/marketplace/products/add_end_uses_to_products',
      {products: products, end_uses: end_uses, authenticity_token: window.token}
    );
  }

  update_product_end_uses(product_id, product_end_uses) {
    return this.$http.post(
      '/admin/marketplace/products/update_product_end_uses',
      {product_id: product_id, product_end_uses: product_end_uses, authenticity_token: window.token}
    );
  }

  get_product_group_end_uses(product_group_id) {
    return this.$http.get(
      '/admin/marketplace/products/get_product_group_end_uses',
      {params: {product_group_id: product_group_id}}
    );
  }
}

ProductService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/product.service.js